// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OverviewVertical-module__wrapper___gWSl8","row":"OverviewVertical-module__row___uxDiU","ellipsis":"OverviewVertical-module__ellipsis___0fXl-"};